import React, { Component } from 'react';
import axios from 'axios';
import * as ReactBootStrap from 'react-bootstrap';

// Supabase (catálogo de planes): API pública con su propia apikey, distinta de
// la API de Medicall24. Se usa una instancia de axios aparte (sin el interceptor
// de Navbar.js) para que no le pise el header Authorization con el token de Medicall24.
const SUPABASE_URL = "https://ukvjbkxaqzltngpbrdfi.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrdmpia3hhcXpsdG5ncGJyZGZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYyODE5NTcsImV4cCI6MjA1MTg1Nzk1N30.3CrdWxYa5Rme_1Zbhi3peYRfsA35j4eUnPZyWlMsQ1M";
const axiosSupabase = axios.create({
  headers: {
    apikey: SUPABASE_ANON_KEY,
    Authorization: "Bearer " + SUPABASE_ANON_KEY
  }
});

/**
 * Selector de planes de suscripción del ecosistema. Se autoalimenta al montarse
 * (no depende de estado del componente que lo use), así que se puede colocar
 * tal cual en cualquier pantalla: la pestaña "Suscripción" de Perfil.js y el
 * modal de aviso de "sin suscripción activa" en Publicaciones.js.
 */
class SeleccionPlanes extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cargando_catalogo_planes: false,
      CatalogoPlanes: [],
      planSeleccionado: null
    }
  }

  componentDidMount() {
    this.Cargar_CatalogoPlanes()
  }

  Cargar_CatalogoPlanes(){
    this.setState({ cargando_catalogo_planes: false })

    axiosSupabase.get(SUPABASE_URL+"/rest/v1/eco_plan_catalog?select=*")
    .then((response) => {
      console.log(response.data);
      const filas = (response.data || []).filter((fila)=> String(fila.id) !== '1')
      this.setState({
        CatalogoPlanes: filas,
        planSeleccionado: filas.length ? filas[0].plan_id : null,
        cargando_catalogo_planes: true
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({ cargando_catalogo_planes: true })
    })
  }

  Capitalizar(texto){
    return (texto || '').trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
  }

  FormatoMoneda(valor){
    return '$' + Number(valor || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 }) + ' COP'
  }

  // Filas del catálogo agrupadas por plan_id (ya viene sin el plan_id=1, filtrado al cargar).
  Planes_agrupar(){
    const grupos = {}
    this.state.CatalogoPlanes.forEach((fila)=>{
      const clave = fila.plan_id
      if (!grupos[clave]) grupos[clave] = []
      grupos[clave].push(fila)
    })
    return grupos
  }

  // No hay un campo de "nombre" documentado para el plan, se resuelve con alternativas.
  Planes_obtenerNombre(fila){
    return (fila && (fila.plan_name || fila.nombre_plan || fila.plan_slug)) || ('Plan ' + (fila ? fila.plan_id : ''))
  }

  Planes_obtenerEtiquetaPeriodo(billing_period){
    const clave = (billing_period || '').toString().trim().toLowerCase()
    if (clave === 'annual' || clave === 'yearly' || clave === 'anual') {
      return { titulo: 'Precio por año', subtitulo: 'Suscripción por 12 meses', facturacion: 'Facturación anual' }
    }
    if (clave === 'monthly' || clave === 'mensual') {
      return { titulo: 'Precio por mes', subtitulo: 'Suscripción por 30 días', facturacion: 'Facturación mensual' }
    }
    return { titulo: this.Capitalizar(billing_period), subtitulo: '', facturacion: this.Capitalizar(billing_period) }
  }

  Planes_calcularPrecioAcsc(precioBase, descuentoPct){
    const base = Number(precioBase) || 0
    const descuento = Number(descuentoPct) || 0
    return Math.round(base - (base * descuento / 100))
  }

  Planes_construirUrlSuscripcion(fila){
    const identificacion = sessionStorage.getItem('identificacion_profesional')
    return 'https://appmedicall24.com/ecosistema-medico-360/suscribir/registro'
      + '?plan=' + encodeURIComponent(fila.plan_id)
      + '&billing=' + encodeURIComponent(fila.billing_period)
      + '&id=' + encodeURIComponent(identificacion)
      + '&redirect=true'
  }

  render(){

    if (this.state.cargando_catalogo_planes===false) {
      return (
        <div className="d-flex justify-content-center">
          <ReactBootStrap.Spinner animation="border" />
        </div>
      )
    }

    const grupos = this.Planes_agrupar()
    const idsPlanes = Object.keys(grupos)

    if (!idsPlanes.length) {
      return (
        <div className="d-flex justify-content-center">
          <h6>No hay planes disponibles por el momento</h6>
        </div>
      )
    }

    const planActivoId = (this.state.planSeleccionado!==null && grupos[this.state.planSeleccionado]) ? this.state.planSeleccionado : idsPlanes[0]
    const filasPlanActivo = grupos[planActivoId] || []

    return (
      <div id="seleccion_planes">

        <div className="text-center">
          <h4>Selecciona el plan que mejor se adapte a tus necesidades</h4>
        </div>

        <div className="d-flex justify-content-center my-4">
          <div id="selector_planes_pill">
            {idsPlanes.map((idPlan)=>{
              const activo = String(idPlan)===String(planActivoId)
              return (
                <button
                  key={idPlan}
                  type="button"
                  className={activo ? 'btn_plan_activo' : 'btn_plan_inactivo'}
                  onClick={()=> this.setState({ planSeleccionado: idPlan })}
                >
                  {activo ? <i className="fas fa-star mr-2"></i> : null}{this.Planes_obtenerNombre(grupos[idPlan][0])}
                </button>
              )
            })}
          </div>
        </div>

        <div className="row justify-content-center">
          {filasPlanActivo.map((fila, indice_fila)=>{

            const periodo = this.Planes_obtenerEtiquetaPeriodo(fila.billing_period)
            const precioBase = Number(fila.base_monthly_cop) || 0

            const tieneDescuentoStandard = Number(fila.standard_discount_pct) > 0
            const precioStandard = this.Planes_calcularPrecioAcsc(precioBase, fila.standard_discount_pct)

            const tieneDescuentoAcsc = Number(fila.acsc_discount_pct) > 0
            const precioAcsc = this.Planes_calcularPrecioAcsc(precioBase, fila.acsc_discount_pct)
            const ahorro = precioBase - precioAcsc

            return (
              <div className="col-md-5 col-sm-12 mb-4" key={indice_fila}>
                <div className="card" id="tarjeta_plan_suscripcion">
                  <div className="card-body text-center">

                    <h5 id="titulo_plan">{periodo.titulo}</h5>
                    <p id="act_plan">{periodo.subtitulo}</p>

                    <div className="d-flex justify-content-center align-items-baseline flex-wrap" id="fila_precio_base">
                      {tieneDescuentoStandard ? (
                        <span className="precio_tachado mr-2">{this.FormatoMoneda(precioBase)} / mes</span>
                      ) : null}
                      <h4 className="mb-0">{this.FormatoMoneda(tieneDescuentoStandard ? precioStandard : precioBase)} / mes</h4>
                    </div>

                    {tieneDescuentoAcsc ? (
                    <React.Fragment>
                      <p className="mb-1">
                        Afiliados a la ACSC <span className="badge badge-acsc">Descuento -{fila.acsc_discount_pct}%</span>
                      </p>
                      <div id="precio_acsc_destacado">
                        <h3 className="mb-0" id="info">{this.FormatoMoneda(precioAcsc)} / mes</h3>
                        <small>Ahorro: {this.FormatoMoneda(ahorro)} / mes</small>
                      </div>
                    </React.Fragment>
                    ) : null}

                    <p className="mt-3 mb-2" id="act_plan">{periodo.facturacion}</p>

                    <a href={this.Planes_construirUrlSuscripcion(fila)} target="_blank" rel="noopener noreferrer" id="btn_suscribirme">
                      Suscribirme
                    </a>

                  </div>
                </div>
              </div>
            )
          })}
        </div>

      </div>
    )
  }

}

export default SeleccionPlanes;
